<template>
  <div>
    <v-row>
      <v-col>
        <v-toolbar dense>
          <v-btn @click="backToDashboard" icon>
            <v-icon>mdi-keyboard-backspace</v-icon>
          </v-btn>
          <span
            class="title"
            v-if="getCurrentClient && getCurrentClient.name != ''"
          >{{ getCurrentClient.name }}</span>
          <v-spacer></v-spacer>
          <v-btn
            class="ma-2"
            outlined
            x-small
            fab
            :disabled="switchEdit == false"
            type="submit"
            @click="saveClientForm"
          >
            <v-icon>mdi-floppy</v-icon>
          </v-btn>
          <v-dialog v-model="deleteDialog" persistent max-width="290">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" class="ma-2" outlined x-small fab :disabled="switchEdit == false">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="sub-title">Confirmar eliminação?</v-card-title>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" text small @click="confirmDelete(true)">Sim</v-btn>
                <v-btn color="error" @click="confirmDelete(false)">Não</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- <v-switch v-model="switchEdit" label="Edit"></v-switch> -->
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="saveClientForm">
          <v-row>
            <v-col cols="6" sm="6" md="6">
              <v-row>
                <v-col>
                  <v-card>
                    <v-card-title>Profile</v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            label="Name"
                            :rules="rules"
                            hide-details="auto"
                            v-model="client.name"
                            outlined
                            placeholder="Name"
                            :disabled="switchEdit == false"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            v-model="client.nif"
                            label="Nif"
                            hide-details="auto"
                            outlined
                            placeholder="Nif"
                            :disabled="switchEdit == false"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            label="Email"
                            :rules="rulesEmail"
                            hide-details="auto"
                            v-model="client.email"
                            outlined
                            placeholder="Email"
                            :disabled="switchEdit == false"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-card>
                    <v-card-title>Websites</v-card-title>
                    <v-card-text>
                      <div
                        v-if="getCurrentClient && 
                        getCurrentClient.website != null && 
                        getCurrentClient.website.length > 0"
                      >
                        <v-list-item v-for="(ws, index) in getCurrentClient.website" :key="index">
                          <v-list-item-content>
                            <v-list-item-title>{{ ws }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </div>
                      <div v-else>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>No websites added yet</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </div>
                      <div>
                        <v-text-field
                          label="Website"
                          v-model="website"
                          hide-details="auto"
                          outlined
                          placeholder="Website"
                          :disabled="switchEdit == false"
                        ></v-text-field>
                      </div>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn dark absolute bottom small right fab @click="addWebsiteToArray">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <v-row>
                <v-col>
                  <v-card>
                    <v-card-title>State</v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-radio-group
                            v-model="client.state"
                            row
                            :disabled="switchEdit == false"
                            :rules="rules"
                          >
                            <v-radio label="Client" value="client" color="green"></v-radio>
                            <v-radio label="Lead" value="lead" color="yellow"></v-radio>
                            <v-radio label="Lost" value="lost" color="red"></v-radio>
                          </v-radio-group>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-card>
                    <v-card-title>Agents</v-card-title>
                    <v-card-text>
                      <v-col cols="12" sm="12" md="12">
                        <v-list two-line dense v-if="getCurrentClient != null">
                          <v-list-item-group v-for="(agent, i) in getCurrentClient.agents" :key="i">
                            <template>
                              <v-list-item>
                                <template>
                                  <v-avatar color="red" style="margin-right:10px">
                                    <span
                                      class="white--text headline"
                                      v-if="agent.name"
                                    >{{ agent.name.substring(0, 1) }}</span>
                                    <span class="white--text headline" v-else>A</span>
                                  </v-avatar>
                                  <v-list-item-content>
                                    <v-list-item-title>{{ agent.name }}</v-list-item-title>
                                    <v-list-item-title>{{ agent.email }}</v-list-item-title>
                                    <v-list-item-subtitle class="text--primary">{{ agent.phone }}</v-list-item-subtitle>
                                  </v-list-item-content>

                                  <v-list-item-action>
                                    <v-list-item-action-text>{{ agent.role }}</v-list-item-action-text>
                                  </v-list-item-action>
                                </template>
                              </v-list-item>
                              <v-divider></v-divider>
                            </template>
                          </v-list-item-group>
                        </v-list>
                        <v-row>
                          <v-col cols="6" sm="6" md="6">
                            <v-text-field
                              label="Name"
                              v-model="currentAgent.name"
                              hide-details="auto"
                              outlined
                              placeholder="Nome"
                              :disabled="switchEdit == false"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="6" md="6">
                            <v-text-field
                              label="Email"
                              v-model="currentAgent.email"
                              hide-details="auto"
                              outlined
                              placeholder="Email"
                              :disabled="switchEdit == false"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6" sm="6" md="6">
                            <v-text-field
                              label="Phone"
                              v-model="currentAgent.phone"
                              hide-details="auto"
                              outlined
                              placeholder="Phone"
                              :disabled="switchEdit == false"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="6" md="6">
                            <v-text-field
                              label="Role"
                              v-model="currentAgent.role"
                              hide-details="auto"
                              outlined
                              placeholder="Role"
                              :disabled="switchEdit == false"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn dark absolute bottom small right fab @click="addAgentToClient">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  name: "clientprofile",
  data: () => ({
    /* Form Verifications */
    valid: true,
    rules: [value => !!value || "Required."],
    rulesEmail: [
      value => !!value || "Required.",
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      }
    ],
    client: {
      name: null,
      nif: null,
      email: null,
      state: null,
      website: [],
      agents: []
    },
    website: null,
    switchEdit: true,
    deleteDialog: false,
    currentAgent: {
      name: null,
      phone: null,
      email: null,
      role: null
    },
    isNewClient: false
  }),
  created() {
    this.client = { ...this.getCurrentClient };
    console.log(this.client);
    if (this.client.name === "") {
      this.switchEdit = true;
      this.isNewClient = true;
    }
  },
  computed: {
    ...mapGetters(["getCurrentClient"])
  },
  methods: {
    ...mapActions(["updateClient", "deleteClient"]),
    backToDashboard() {
      if (this.isNewClient) {
        this.deleteClient(this.client.id).then(() => {
          this.$router.push({ name: "clientsdashboard" });
        });
      } else {
        this.$router.push({ name: "clientsdashboard" });
      }
    },
    confirmDelete(b) {
      console.log(b);
      if (b) {
        this.deleteClient(this.client.id).then(() => {
          this.$router.push({ name: "clientsdashboard" });
          this.deleteDialog = false;
        });
      } else {
        this.deleteDialog = false;
      }
    },
    saveClientForm() {
      if (this.$refs.form.validate()) {
        this.updateClient(this.client).then(() => {
          // this.switchEdit = false;
        });
      }
    },
    addWebsiteToArray() {
      this.client.website.push(this.website);
      this.website = null;
    },
    addAgentToClient() {
      if (this.currentAgent.email != null && this.currentAgent.name) {
        this.client.agents.push(this.currentAgent);
        this.currentAgent = {
          name: null,
          phone: null,
          email: null,
          role: null
        };
      }
    }
  }
};
</script>

<style></style>
